import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsUpdatedToday } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsUpdatedToday from '@/features/commands/components/extensions/commands-updated-today'

export const Route = createFileRoute('/_authenticated/commands-updated-today/')(
  {
    component: () => {
      const { t } = useTranslation()
      return (
        <CommandsUpdatedToday
          queryExtension={{
            title: t('sidebar.traitees-aujourdhui'),
            querykey: 'commands-updated-today',
            queryFn: getCommandsUpdatedToday,
          }}
        />
      )
    },
    head: () => ({
      meta: [
        {
          title: `${APP_NAME} | Traitées aujourd'hui`,
        },
      ],
    }),
    validateSearch: validateCommandsPageSearchParams,
  }
)
